// removed by extract-text-webpack-plugin
module.exports = {"button":"_3rzlrpsGc3fdNsfErEzhWb"};


//////////////////
// WEBPACK FOOTER
// ./src/client/Components/SecondaryButton/SecondaryButton.css
// module id = 423
// module chunks = 58